<div class="grid-ilots affichage-label-bordure"
	 [ngClass]="readonly() ? 'center-grid': ''"
	 [style.gap]="tailleGap() + 'px'">
	@if (!isBlank(labelHaut())) {
		<div class="indicateur vertical indication-haut">{{ labelHaut() }}</div>
	}
	@if (!isBlank(labelDroite())) {
		<div class="indicateur horizontal indication-droite">{{ labelDroite() }}</div>
	}
	<div class="contenu-grid"
		 [style.grid-template-columns]="valeurGridColumns()"
		 [style.grid-template-rows]="valeurGridRows()">
		@for (ilot of ilots(); track ilot.id) {
			@for (bureau of ilot.bureaux; track bureau.id) {
				<div class="bureau"
					 [ngClass]="estAffichagePlusieursIlots() || estBureauReservable(bureau) ? 'afficher-cursor-pointer' : ''"
					 [style.width]="tailleBureau()"
					 [style.height]="tailleBureau()"
					 [style.grid-column]="numeroGridColumnBureauParBureauId().get(bureau.id)"
					 [style.grid-row]="numeroGridRowBureauParBureauId().get(bureau.id)"
					 [style.border-bottom-left-radius]="borderBottomLeftRadiusParBureauId().get(bureau.id)"
					 [style.border-bottom-right-radius]="borderBottomRightRadiusParBureauId().get(bureau.id)"
					 [style.border-top-left-radius]="borderTopLeftRadiusParBureauId().get(bureau.id)"
					 [style.border-top-right-radius]="borderTopRightRadiusParBureauId().get(bureau.id)"
					 (click)="onClickIlotOuBureau(ilot, bureau)"
					 (mouseenter)="changerEtatHover(ilot.id, bureau, true)"
					 (mouseleave)="changerEtatHover(ilot.id, bureau, false)"
					 [class.hovered]="determineClasseHoveredPourIlot(ilot)">

					@if (bureau.estReserveDansLaJournee()) {
						<div class="nom-prenom-occupant">{{ recupererNomPrenomOccupant(bureau) }}</div>
					} @else {
						<!-- un padding pour avoir les bureaux alignés entre ceux qui ont un nom au dessus et ceux qui en ont pas -->
						<div class="nom-prenom-vide">&nbsp;</div>
					}

					<app-affichage-bureau
							[readonly]="readonly()"
							[utilisateurConnecte]="utilisateurConnecte()"
							[bureauPreferentielId]="bureauPreferentielId()"
							[dureeReservationEnCours]="duree()"
							[bureauIdCourant]="bureauIdCourant()"
							[bureau]="bureau"
							[declencherHoverIndicateurBureau]="determinerClasseHoveredIndicateurBureau(bureau)"/>
				</div>
			}
		}

		@if (estAfficherLabelIlot()) {
			@for (ilot of ilots(); track ilot.id) {
				<div
						class="labels-ilots"
						[style.grid-column]="numeroGridColumnLabelIlotParIlotId().get(ilot.id)"
						[style.grid-row]="numeroGridRowLabelIlotParIlotId().get(ilot.id)"
						[style.left]="valeurLeftLabelIlot().get(ilot.id)"
						[style.top]="valeurTopLabelIlot().get(ilot.id)"
						[style.background-color]="ilot.couleur">
					<span>{{ ilot.nom }}</span>
				</div>
			}
		}
	</div>
	@if (!isBlank(labelBas())) {
		<div class="indicateur vertical indication-bas">{{ labelBas() }}</div>
	}
	@if (!isBlank(labelGauche())) {
		<div class="indicateur horizontal indication-gauche">{{ labelGauche() }}</div>
	}
</div>
